import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const drawer = css`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`
export const notifications = css`
  inset-block-end: ${spacing(2)};
`
